import * as React from "react";

import { OnderhoudPageEn } from "./OnderhoudPage-en";
import { OnderhoudPageNl } from "./OnderhoudPage-nl";
import { IOnderhoudPageProps } from "./IOnderhoudPageProps";

export function OnderhoudPage (props: IOnderhoudPageProps) {
  return props.language === "nl" ? <OnderhoudPageNl {...props} /> : <OnderhoudPageEn {...props} />;
}
